import React from 'react';
import Fade from 'react-reveal/Fade';

const Contact = () => {
  return (
    <div className="contact-page-wrapper">
      <Fade big bottom>
    <h1 className="primary-heading">Have Queries In Mind?</h1>
    <h1 className="primary-heading">Let Us Help You</h1>
    <div className="contact-form-container">
      <input type="text" placeholder="yourmail@gmail.com" />
      <button className="secondary-button">Submit</button>
    </div>
      </Fade>
  </div>
  )
}

export default Contact